export interface IFields {
  id?: number
  uuid?: string
  name?: string
  production_demo_code?: string
  abbreviate?: string
  description?: string
  region?: string
  concession_contract_number?: number
  geom_polygon?: string
  
}


export const fieldsInitValues: IFields = {
  //id: 0,
  name: '',
  production_demo_code: '',
  abbreviate: '',
  description: '', 
}

